import useLocalStorage from '@rehooks/local-storage';
import React from 'react';
import { useRouterQuery } from './useRouterQuery';

const darkModeClass = 'darkMode';

export const useDarkMode = () => {
  const [query] = useRouterQuery();
  const [_lightModeChecked] = useLocalStorage('lightMode', 'AUTO');

  const lightModeChecked = query.themeMode != null ? query.themeMode : _lightModeChecked;
  React.useEffect(() => {
    const listener = (event: MediaQueryListEvent | { matches: boolean }) => {
      if (event.matches) {
        document.body.classList.add(darkModeClass);
        document.body.classList.add('dark');
      } else {
        document.body.classList.remove(darkModeClass);
        document.body.classList.remove('dark');
      }
    };
    if (lightModeChecked === 'DARK') {
      listener({ matches: true });
    } else if (lightModeChecked === 'LIGHT') {
      listener({ matches: false });
    } else {
      const darkMode = window.matchMedia('(prefers-color-scheme: dark)');
      listener(darkMode);
      darkMode.addEventListener('change', listener);
      return () => {
        darkMode.removeEventListener('change', listener);
      };
    }
  }, [lightModeChecked]);
};
